import * as types from '../mutation-types'

// initial state
const state = {
  title: null,
  debug: process.env.NODE_ENV !== 'production',
  entry_route: null,
}

// getters
const getters = {

}

// actions
const actions = {

}

// mutations
let mutations = {}

mutations[types.SET_TITLE] = function (state, r) {
  state.title = r
}

mutations[types.SET_ENTRY_ROUTE] = function (state, r) {
  if (state.entry_route === null) {
    state.entry_route = r
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/global.js